export default {
  LOAD_PERSON (state, payload) {
    state.personObject = payload
  }
}



// WEBPACK FOOTER //
// ./src/app/person/vuex/mutations.js